import { render } from "./status-badge.vue?vue&type=template&id=0744f19b"
import script from "./status-badge.vue?vue&type=script&lang=js"
export * from "./status-badge.vue?vue&type=script&lang=js"

import exportComponent from "/home/eymekkjd/infos-projet.app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__